import NextImage from 'next/image';

import { getMapWithFishrulesSpeciesUrl } from '../../helpers/urls';
import { ICoordinates } from '../../interfaces/geo';
import { NonCrawlableLink } from '../Clickables/NonCrawlableLink/NonCrawlableLink';
import { getStaticPlaceMap } from '../Maps/mapData/staticMaps';
import { StaticMapPlaceholder } from '../Placeholder/StaticMapPlaceholder';
import { MapboxAttribution } from '../MapboxAttribution/MapboxAttribution';

interface IProps {
  coordinates: ICoordinates;
}

const MAP_WIDTH = 600;
const MAP_HEIGHT = 250;

export const StaticPlaceMap = ({ coordinates: { latitude, longitude } }: IProps) => {
  return (
    <NonCrawlableLink
      routerPushTo={getMapWithFishrulesSpeciesUrl(latitude, longitude)}
      ariaLabel="go to map"
    >
      <div className="bg-sea-foam relative size-full rounded-b-lg pb-[41%] sm:mx-0">
        <StaticMapPlaceholder />
        <NextImage
          alt="map of the current location"
          className="absolute top-0 left-0 size-full rounded-b-lg object-center"
          src={getStaticPlaceMap(
            longitude.toString(),
            latitude.toString(),
            MAP_WIDTH,
            MAP_HEIGHT,
            'hybrid',
          )}
          width={MAP_WIDTH}
          height={MAP_HEIGHT}
          unoptimized
        />
        <MapboxAttribution isLinked={true} />
      </div>
    </NonCrawlableLink>
  );
};
